import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRecoilValue } from 'recoil';
import { ChatEvent } from '@/components/ChatEvent/ChatEvent';
import { EmptyMessage } from '@/components/ChatEvents/EmptyMessage';
import { WelcomeWrapper } from '@/components/WelcomeScreen/WelcomeWrapper';
import { useChatEvents } from '@/hooks/useChatEvents';
import { welcomeScreenSelector } from '@/state/config';
export const ChatEvents = () => {
    const welcomeScreen = useRecoilValue(welcomeScreenSelector);
    const chatEvents = useChatEvents();
    return (_jsxs(_Fragment, { children: [chatEvents.length === 0 && !(welcomeScreen === null || welcomeScreen === void 0 ? void 0 : welcomeScreen.enabled) && _jsx(EmptyMessage, {}), chatEvents.length === 0 && (welcomeScreen === null || welcomeScreen === void 0 ? void 0 : welcomeScreen.enabled) && (_jsx(WelcomeWrapper, { welcomeScreen: welcomeScreen })), chatEvents === null || chatEvents === void 0 ? void 0 : chatEvents.map((event) => {
                return _jsx(ChatEvent, { event: event }, event.event_id);
            })] }));
};
